import { Injectable } from "@angular/core";
import { Adapter } from "../../../records/classes/adapter";
import { DomainFieldwork, Fieldwork } from "./fieldwork";

@Injectable({ providedIn: "root" })
export class FieldworkAdapter extends Adapter<Fieldwork, any> {
  toView(plan: DomainFieldwork) {
    return new Fieldwork(plan);
  }
}
